var ListingCategory;
(function (ListingCategory) {
  ListingCategory["BUY"] = "BUY";
  ListingCategory["RENT"] = "RENT";
  ListingCategory["SHARE"] = "SHARE";
  ListingCategory["DEVELOPMENTS"] = "DEVELOPMENTS";
})(ListingCategory || (ListingCategory = {}));
export default ListingCategory;